var exports = {
  "D": "xa15a2ab7--f76130--title",
};

module.exports = exports;
